import {
  CERTIFICATES_DATA,
  TEAM_CERTIFICATES_DATA,
} from "../../constant/CompanyData";
import { FaDownload } from "react-icons/fa";
import Eyebrow from "../common/Eyebrow";

const CertificatesSection = () => {
const renderCertificateGrid = (data) => (
  <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
    {data.map((cert) => (
      <div
        key={cert.id}
        className="group relative rounded-2xl border border-slate-200 bg-white p-6 text-left shadow-sm"
      >
        <a
          href={cert.file}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="absolute right-4 top-4 text-slate-400"
          title="Download Certificate"
        >
          <FaDownload size={18} />
        </a>

        <h3 className="pr-8 text-lg font-semibold text-[var(--website-primary-color)]">
          {cert.title}
        </h3>

        <p className="mt-2 text-sm leading-relaxed text-slate-600">
          {cert.description}
        </p>

        <p className="mt-3 text-xs text-slate-500">
          <span className="font-semibold">Issued:</span> {cert.issueDate}

          {cert.expiryDate && cert.expiryDate !== "-" && (
            <>
              {" "}
              &middot;{" "}
              <span className="font-semibold">Expires:</span>{" "}
              {cert.expiryDate}
            </>
          )}
        </p>

        <div className="mt-5 flex justify-center overflow-hidden rounded-xl border border-slate-200 bg-slate-50 p-2">
          <img
            src={require(`../../assets/Services/certificates/${cert.imgSrc}`)}
            alt={cert.title}
            className="h-72 w-full object-contain"
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
    ))}
  </div>
);
  return (
    <div className="bg-white">
      <section className="bg-white px-6 py-20">
        <div className="mx-auto max-w-6xl">
          <div className="text-center">
            <Eyebrow>Certifications</Eyebrow>
          </div>
          <h2 className="mx-auto mt-3 max-w-3xl text-center text-3xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-4xl">
            Our Certifications
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center leading-relaxed text-slate-600">
            Certified in globally recognized standards ensuring trust and
            compliance.
          </p>
          {renderCertificateGrid(CERTIFICATES_DATA)}
        </div>
      </section>

      <section className="bg-slate-50 px-6 py-20">
        <div className="mx-auto max-w-6xl">
          <div className="text-center">
            <Eyebrow>Our people</Eyebrow>
          </div>
          <h2 className="mx-auto mt-3 max-w-3xl text-center text-3xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-4xl">
            Team Certifications
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center leading-relaxed text-slate-600">
            Showcasing the expertise of our skilled professionals through
            global certifications.
          </p>
          {renderCertificateGrid(TEAM_CERTIFICATES_DATA)}
        </div>
      </section>
    </div>
  );
};

export default CertificatesSection;
